export default __webpack_public_path__ + "maps-guides-view-annotation-simple-960-743b61d45fee1926e8ff39bc539320d4.png";